import {
    AudienceTargetingsType,
    AudienceTargetingsValue,
    CryptaAudioGenresEditorState,
    CryptaBehavioralEditorState,
    CryptaGroupFamilyEditorState,
    CryptaSocialDemoEditorState,
    InterestsTargetingEditorState
} from '../../typings/audienceTargetings';

export function mapCurrentAudienceTargetings(
    audienceTargetingsEditors: {
        interestsTargetingEditor?: InterestsTargetingEditorState;
        cryptaSocialDemoEditor?: CryptaSocialDemoEditorState;
        cryptaGroupFamilyEditor?: CryptaGroupFamilyEditorState;
        cryptaAudioGenresEditor?: CryptaAudioGenresEditorState;
        cryptaBehavioralEditor?: CryptaBehavioralEditorState;
    },
    groupAudienceTargetings: AudienceTargetingsValue
): AudienceTargetingsValue {
    return {
        [AudienceTargetingsType.socialDemo]: audienceTargetingsEditors.cryptaSocialDemoEditor
            ? audienceTargetingsEditors.cryptaSocialDemoEditor.checkedItems
            : groupAudienceTargetings[AudienceTargetingsType.socialDemo],
        [AudienceTargetingsType.behaviors]: audienceTargetingsEditors.cryptaBehavioralEditor
            ? audienceTargetingsEditors.cryptaBehavioralEditor.checkedItems
            : groupAudienceTargetings[AudienceTargetingsType.behaviors],
        [AudienceTargetingsType.family]: audienceTargetingsEditors.cryptaGroupFamilyEditor
            ? audienceTargetingsEditors.cryptaGroupFamilyEditor.checkedItems
            : groupAudienceTargetings[AudienceTargetingsType.family],
        [AudienceTargetingsType.audioGenres]: audienceTargetingsEditors.cryptaAudioGenresEditor
            ? audienceTargetingsEditors.cryptaAudioGenresEditor.checkedItems
            : groupAudienceTargetings[AudienceTargetingsType.audioGenres],
        [AudienceTargetingsType.interests]: audienceTargetingsEditors.interestsTargetingEditor
            ? audienceTargetingsEditors.interestsTargetingEditor.value
            : groupAudienceTargetings[AudienceTargetingsType.interests],
        [AudienceTargetingsType.audienceMetrics]:
            groupAudienceTargetings[AudienceTargetingsType.audienceMetrics]
    };
}
